import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {TaskModel} from '../../../models/task.model';

@Component({
    selector: 'app-task-detail',
    templateUrl: './task-detail.component.html',
    styleUrls: ['./task-detail.component.scss']
})
export class TaskDetailComponent implements OnInit {
    public taskId;
    public alias: string;

    constructor(
        protected activeRoute: ActivatedRoute,
        protected router: Router
    ) {
    }

    ngOnInit(): void {
        this.activeRoute.params.subscribe((param: any) => {
            this.taskId = param.id;
            this.alias = param.alias;
        });
    }

    async onLoadTask(task: TaskModel | boolean): Promise<void> {
        if (!task) {
            await this.router.navigate(['/account/tasks']);
        }
    }

    async onDeleteTask(isDelete: boolean): Promise<void> {
        if (isDelete) {
            await this.router.navigate(['/account/tasks']);
        }
    }
}
